export default class Stores {
    constructor() {
        this.section = document.querySelector('.components-stores');
        this.selectRegions = this.section.querySelector('#mobileSelectRegion');

        this.hash = document.querySelector('#lojas');

        this.ready();
    }

    ready() {
        if (this.selectRegions) {
            this.selectRegions.addEventListener('change', () => {
                location.href = this.selectRegions.value;
            });
        }

        if (window.location.hash && window.location.hash === '#lojas') {
            this.scrollToStoresSection();
        }
    }

    scrollToStoresSection() {
        setTimeout(() => {
            const idSection = document.getElementById('lojas');
     
            if (idSection) {
                const titlePosition = idSection.getBoundingClientRect().top + window.pageYOffset;
                const scrollPosition = titlePosition;
                
                window.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    }
}
if (document.querySelector('.components-stores')) {
    new Stores();
}
